import React from 'react'

const Ecologyandenvironment = () => {
  return (
    <div>
      <div>
        <h3>Working with words</h3>
        <p className='question'>A. The words/phrases in the box are from the text. Check their meanings in a dictionary and use these words to complete the given sentences.</p>

<p>a. <strong>Logging</strong> is one of the main reasons behind the rapid deforestation in the world.</p>

<p>b. That's one example of how the pandemic should be a <strong>wake-up call</strong>.</p>

<p>c. <strong>Propane</strong> is a gas used as a <strong>fuel</strong> for cooking and heating.</p>

<p>d. Emergency teams are still clearing the <strong>debris</strong> from the plane crash.</p>

<p>e. What a <strong>transformation</strong>! You look great.</p>

<p>f. My father made a New Year's <strong>resolution</strong> to give up smoking.</p>

<p>g. He has worked in the Army for two years. He hates that two-year <strong>stint</strong>.</p>

<p>h. Emissions from the factory are widely suspected of having a <strong>detrimental</strong> effect <strong>on</strong> health.</p>

<p>i. My father is an <strong>occasional</strong> smoker. He doesn't smoke often.</p>

<p>j. <strong>Redwood</strong> is a very tall type of tree that grows especially in California and Oregon.</p>

      </div>
      <hr/>
      <div>
        <p className='question'>B. The words redwood, barefoot, single-burner, short-term, fast-paced, mudslide, windstorm and childhood from the above text are made of two words and they yield a new meaning. Compound words can be written in three ways: open compounds (spelled as two words, e.g, ice cream), closed compounds (joined to form a single word, eg, doorknob), or hyphenated compounds (two words joined by a hyphen, eg, long-term). Choose one word from each box to make sensible compound words. </p>
        <p>rattle = rattlesnake (closed compound)</p>
        <p>sun = sunlight (closed compound)</p>
        <p>touch = touchdown (closed compound)</p>
        <p>moon = moonlight (closed compound)</p>
        <p>day = daydream (closed compound)</p>
        <p>fire = fireworks (closed compound)</p>
        <p>water = watermelon (closed compound)</p>
        <p>basket = basketball (closed compound)</p>
        <p>pass = password (closed compound)</p>
        <p>wash = dishwash (closed compound)</p>
         <p>weather = weatherproof (closed compound)</p>
         <p>grand = grandmother (closed compound)</p>
         <p>cross = crosswalk (closed compound)</p>
      </div>
      <hr/>
      <div>
        <p className='question'>C. Match the following words/phrases related to the ecology with their meanings.</p>

<p>a. <strong>Sustainability</strong> — to keep in existence; maintain. To supply with necessities or nourishment.</p>

<p>b. <strong>Tree line</strong> — the height on a mountain above which the climate is too cold for trees to grow.</p>

<p>c. <strong>Precipitation</strong> — water that returns to the earth as rain, hail, sleet, or snow.</p>

<p>d. <strong>Tropical zone</strong> — the region between latitudes 23.5° S and 23.5° N.</p>

<p>e. <strong>Kyoto Protocol</strong> — an agreement between countries to reduce their greenhouse gas emissions. It was established in Japan in 1997 but didn't become international law until 2004.</p>

<p>f. <strong>Pollutants</strong> — substances that destroy the purity of air, water, or land.</p>

<p>g. <strong>Geosphere</strong> — the soils, sediments, and rock layers of the Earth's crust, both continental and beneath the ocean floors.</p>

<p>h. <strong>Deciduous</strong> — a plant that sheds all or nearly all its leaves each year.</p>

<p>i. <strong>Ephemeral</strong> — an organism that has a short life cycle.</p>

<p>j. <strong>Trash</strong> — items that are discarded.</p>
</div>
<div>
    <hr/>
    <h3>Comprehension</h3>
    <p className='question'>A. Choose the best answer.</p>
    <p>a. The author of the text above has the opinion that Julia Hill .........</p>
    <p><strong>ii. made her pastime in a tree for two years more</strong></p>
    <p>b. The sentence 'Julia had occasional visitors' indicates she had .......</p>
    <p><strong>ii. a few visitors now and then</strong></p>
    <p>c. The logging company managed 24 hour security service around the tree to .......</p>
    <p><strong>ii. discourage her from her campaign</strong></p>
    <p>d. Ms. Hill began to respond the loggers with songs and conventional conversations because she ........</p>
    <p><strong>ii. had unconditional love for all nature's creations</strong></p>
    <p>e. Julia Hill climed down the tree after 738 days when her demands were ........</p>
    <p><strong>iii. above to be fulfilled.</strong></p>
</div>
<hr/>
<div>
    <p className='question'>B. Answer the following questions.</p>
    <p className='question'>a. Who was Julia Butterfly Hill? How did Hill's campaign gain popularity?</p>
    <p>= Julia Butter Jill was a person who lived in a 200-ft-tall redwood tree for more than two years to draw attention to the continued clearcutting of California's remaining redwood forests. Her campaign gained popularity when she started to have occasional visitors.
</p>
    <p className='question'>b. What made Hill start her mega campaign to save redwood trees?</p>
    <p>= When she arrived in the redwood forest, she was gripped by the spirit of the forest. She dropped to her knees and began to sob seeing the clearcutting of redwood trees. She sat and cried for a long time and finally decided to start her mega campaign to save redwood trees.</p>

    <p className='question'>c. What kinds of amenities were there to support Hill's life in the tree?</p>
    <p>= Hill had a sleeping bag, a solar-powered cell phone for media interviews, and a single-burner propane stove to cook and heat water to support her life in the tree. She had few necessities, and no luxuries.</p>

    <p className='question'>d. Did Hill's value of life change after her car accident? How?</p>
    <p>= Yes, Hill's value of life changed after her car accident. She said the experience was a wake-up call. Before accident her main focus had been work but later on she became clear that value as people is not in their stock portfolios and bank accounts, but it is in the legacies they leave behind.</p>

    <p className='question'>e. Deforestation causes natural calamities. What evidence do you have in the text to prove this?</p>
    <p>= Yes it's true that deforestation causes natural calamities. In the text we can see that the cutting of redwoods destabilized the hillside and caused the mudslide which carried trees, stumps and debris from that hillside down into the town, leaving seven families without homes.</p>

    <p className='question'>f. How did the logging company try to discourage Hill in the early days of her sit-in ?</p>
    <p>= The logging company tried to discourage Hill in the early days of her sit-in by hiring 24-hour security guards to harass her and to ensure her support team couldn't deliver her supplies. She was menaced with a helicopter at a dangerously close range. A neighboring tree was felled, hitting Luna's outer branches and nearly causing Hill to fall. She was verbally abused, threatened with violence, rape and death, kept awake with floodlights, and bugles and air horns were blown through the night.</p>

    <p className='question'>g. How were the vagaries of nature unwelcoming to Hill?</p>
    <p>= The logging company wasn't her only problem. One of her scariest times was a 16-hour, 70-mph windstorm that shredded the tarps that surrounded her, and even ripped huge branches off the tree. When lightning struck nearby during an electrical storm, her hair stood straight up. In this way the vagaries of nature were unwelcoming to Hill.</p>

    <p className='question'>h. What is the purpose of the author to write a review on Hill's book? Do you think the author stands for ecological sustainability? Give reasons.</p>
    <p>= The purpose of the author to write a review on Hill's book is to bring a spotlight to the issue of deforestation. He wants people to learn about the deforestation and its ill effects through his review and make people know about what a person should do to prevent from this should. Yes I think the author stands for ecological sustainability.</p>
</div>

<div>
    <hr/>
    <h3>Critical thinking</h3>
    <p className='question'> Suppose you are Julia Butterfly Hill. After staying one year in the tree, the government offered you five million dollars and requested you to drop the strike. Write in about 200 words responding them that the money is a mean thing for you in comparison with the woods.</p>
    <p>Dear Representatives,</p>
    <p>I deeply appreciate your offer, but I must respectfully decline.</p>
    <p>Living in this tree for the past year has been more than a protest—it has become a spiritual journey and a responsibility I cannot ignore. The redwoods are not just trees; they are ancient beings, protectors of ecosystems, and symbols of life's balance. Their roots hold the earth together, their branches give shelter to countless species, and their very presence reminds us of what true wisdom and endurance look like.</p>
    <p>Offering me five million dollars to walk away might seem generous, but it reveals how disconnected we have become from what truly matters. Money cannot replace a living tree, a thriving forest, or a stable ecosystem. Once these giants are gone, no amount of wealth can bring them back.</p>
    <p>My purpose here is not for fame, wealth, or comfort, but to speak on behalf of those who cannot speak—the trees, the animals, and the future generations who will inherit this planet. I am not sitting in this tree because I want something. I am here because I have something to give.</p>
    <p>And that something—my voice, my time, my dedication—is not for sale.</p>
    <p>Sincerely,</p>
    <p>Julia Butterfly Hill</p>
</div>
<div>
    <hr/>
    <h3>Writing</h3>
        <p className='question'>A. Write a review of a book/flim which you have read/watched recently.</p>
        <h5>Seto Dharti</h5>
        <p>Title of the Book: Seto Dharti</p><p>
Author of the Book: Amar Neupane</p><p>
Country: Nepal</p><p>
Language: Nepali</p><p>
First Originally Published by: FinePrint Publication in 2012</p><p>
Genre: Historical Fiction / Social Realism</p><p>
Cost of the Book: Rs. 450</p><p>
Name of the Publisher: FinePrint Publication</p><p>
Edition and Year of Copyright: First Edition, 2012</p><p>
No. of Pages: 288</p><p>
Writing Style: Descriptive and Reflective Narrative</p><p>
Characters: Tara (main character), her parents, village elders, priests</p><p>

Plot:</p><p>
Seto Dharti tells the tragic life story of Tara, a girl who is married off at a very young age and becomes a widow before she even understands what marriage is. The novel traces her emotional and physical journey from childhood to old age. After losing her husband, she is forced to live a life of loneliness and suppression in a conservative society that sees widowhood as a curse. Despite her vibrant personality and desire to live freely, society slowly strips her of color, joy, and choice—leaving her on the metaphorical “white earth.”</p><p>

Summary:</p><p>
The novel explores themes such as child marriage, the condition of women in rural Nepal, and the cruelty of social customs. It spans Tara's entire life, from a cheerful girl to a wise old woman, as she adapts to the life society forces upon her. Along the way, we see not just her personal pain, but also a portrait of traditional Nepali society where outdated customs dictate a woman's fate.</p><p>

My Impressions:</p><p>
Seto Dharti is a heartbreaking and powerful novel that makes the reader reflect on how deeply rooted traditions can destroy lives. Amar Neupane's writing is lyrical and full of emotion. Tara's story is quiet, but unforgettable. It made me feel the pain of millions of women who never got to live life on their own terms. The use of “white” (seto) as a symbol of widowhood, emptiness, and purity is beautifully woven throughout the story. This book is not just literatur it's a voice for the voiceless. Highly recommended.

</p>
        <hr/>
       <p className='question'>B. Your school is going to organize a speech competition on coming Friday. The subject of the speech is "Let's save the trees and protect over environment." Draft a speech using the following prompts.</p>
     <h5>Let's Save the Trees and Protect Our Environment</h5><p>

Good morning everyone,</p><p>
Thank you for giving me the chance to speak on this important topic — Let's Save the Trees and Protect Our Environment.</p><p>

Air is the most important thing we need to live. Trees give us clean air. They take in carbon dioxide and give out oxygen, which we need to breathe. That is why trees are often called the lungs of our planet.</p><p>

But sadly, people are cutting down trees to build buildings and roads. This is called deforestation. It harms nature and makes the planet suffer. When we cut down trees, we get more pollution, hotter temperatures (global warming), animals lose their homes, and the soil becomes weak.</p><p>

If we keep cutting trees like this, future generations will not have clean air or a healthy planet to live on. So, we must plant more trees — this is called afforestation. Planting trees helps save the Earth.</p><p>

Even one tree can make a difference. If we all do our part and plant more trees, we can protect the environment and leave behind a greener, better planet for our children.</p><p>

Let's all remember: Save Trees, Save Lives, Save Earth!</p><p>
Thank you for listening.</p>
</div>
<div>
    <hr/>
    <h3>Grammar</h3>
    <p className='question'>B. Someone says something to you which contradicts to what they told you earlier. Match the beginnings of the conversations with the correct endings.</p>
    <p>a. I'm going to Pokhara on holiday ------ You said you were going business.</p>
    <p>b. He's a lawyer ------ You told me he was a teacher.</p>
    <p>c. She's had a baby girl ------ You said she'd had a boy.</p>
    <p>d. I haven't seen Binesh for ages ------ You told me you'd seen him previous week.</p>
    <p>e. I love these new boots ------ You said you hated them.</p>
    <p>f. I only cheated in one exam ------ You admitted you cheated in all your exams.</p>
    <p>g. She doesn't speak Hindi or Chinese ------ You told me she was fluent in both.</p>
    <p>h. He works in Kathmandu ------ You told me his office was in Biratnagar.</p>
</div>
<div>
    <p className='question'>C. Change the following sentences into indirect speech.</p>
    <p>a. The principal said,"You can phone from my office, Rita."</p>
    <p>= The principal told Rita that she could phone from his office.</p>
    <br/>
    <p>b. "You must not neglect your duty," said the teacher to the student.</p>
    <p>= The teacher told the student that he must not neglect his duty.</p>
    <br/>
    <p>c. The student said,"Sir, please, grant me a leave for two days."</p>
    <p>= The student respectfully requested the sir to grant him a leave for two days.</p>
    <br/>
    <p>d. I said to her,"Go to school or you will be fined."</p>
    <p>= I told her to go to school or she would be fined.</p>
    <br/>
    <p>e. The headmaster said,"Don't make any noise, boys."</p>
    <p>= The headmaster told the boys not to make any noise.</p>
    <br/>
    <p>f. "Work hard if you want to rise in life," said the old man.</p>
    <p>= The old man advised to work hard if one wanted to rise in life.</p>
    <br/>
    <p>g. He said,"Goodbye, my friends!"</p>
    <p>= He bade goodbye to his friends.</p>
    <br/>
    <p>h. She said to me,"Have a pleasant journey ahead."</p>
    <p>= She wished me a pleasant journey ahead.</p>
    <br/>
    <p>i. "Don't give me the book, please," Sharmila said.</p>
    <p>= Sharmila requested not to give her the book.</p>
    <br/>
    <p>j. "Where have you been these days?", she spoke on the telephone.</p>
    <p>= She asked on the telephone where I had been those days.</p>
    <br/>
    <p>k. The teacher said,"Have you submitted your assignments, students?"</p>
    <p>= The teacher asked the students if they had submitted their assignments.</p>
</div>
<hr/>
<div>
    <p className='question'>D. These are the exact words Dinesh said to you yesterday.</p>
    <p>"I've just got engaged! We're getting married next month. We're going Pokhara for our honeymoon. It's all going to be very expensive. Luckily, my friend is a photographer so he'll take the photos for us. We'll be having the reception in my parents' back garden. My mum is baking the cake for us and my sister's band is playing free for us. I hope you'll come to the wedding."</p>
    <p className='question'>Now, you're telling your friend what Dinesh told you. Complete the text.</p>
     <p>He said he <strong>had</strong> just got engaged. He told me that he <strong>was getting married</strong> next month. He told me <strong>they were going</strong> to Pokhara for their honeymoon. He mentioned that it <strong>was going to be</strong> very expensive. He said that his friend <strong>was a photographer</strong> and he <strong>would take</strong> the photos for them. He mentioned that they <strong>would be having</strong> the reception in his parents' garden. He admitted that <strong>his mum was baking the cake for them</strong>. He said his sister's band <strong>was playing free for them</strong>. He said he <strong>hoped</strong> I'd come to the wedding.</p>

</div>
    </div>
  )
}

export default Ecologyandenvironment
